export const itemsPerPage = 10;
export const itemsPerQuery = 20;
